import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Class } from '../../models/class.model';

@Component({
    selector: 'app-class-selector',
    templateUrl: './class-selector.component.html',
    styleUrls: ['./class-selector.component.scss']
})
export class ClassSelectorComponent {

    @Input() classes         : Class[];
    @Input() selected?       : Class;
    @Input() defaultSelected?: boolean = false;
    @Input() placeholder?    : string = 'Seleccione una clase...';
    @Input() showClear?      : boolean = false;
    @Input() showFilter?     : boolean = false;

    @Output() selectedChange = new EventEmitter<Class>();

    constructor() { }

    ngOnInit(): void {

        this.selected = this.defaultSelected ? this.classes[0] : this.selected;
        this.onSelectionChange();

    }

    public onSelectionChange() {

        this.selectedChange.emit(this.selected);

    }

    public getOccupancyPercentageClass(courseClass: Class) : string {

        var percentage = (courseClass.reservedPlaces * 100) / courseClass.totalPlaces;

        if (percentage >= 80) {
            return 'percentage-occupation-high';
        } else if (percentage >= 50) {
            return 'percentage-occupation-medium';
        } else {
            return 'percentage-occupation-low';
        }

    }

    public getFreePlacesText(selectedClass: Class) : string {

        if (selectedClass.freePlaces == 0) { return 'No hay plazas disponibles'; } else
        if (selectedClass.freePlaces == 1) { return 'Sólo queda una plaza disponible'; }

        return 'Quedan ' + selectedClass.freePlaces + ' plazas disponibles';

    }

}
